import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Routes from "routing/Routes";
import { MenuItem } from "components/bootstrap";
import { isSigmaEventDefinition } from "components/event-definitions/event-definitions-types";
const SigmaEventDefinitionSearchAction = ({ entity }) => {
  var _a;
  const { t } = useTranslation("enterprise_security_sigma");
  const eventDefinition = entity;
  const isSigma = isSigmaEventDefinition(eventDefinition);
  const onSearchLogs = useCallback(() => {
    window.open(Routes.ALERTS.DEFINITIONS.replay_search(eventDefinition.id), "_blank");
  }, [eventDefinition.id]);
  if (!isSigma) return null;
  const canSearch = !!((_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.query);
  return /* @__PURE__ */ React.createElement(MenuItem, { disabled: !canSearch, onClick: canSearch ? onSearchLogs : void 0 }, t("event_definition_search_action.replay_search"));
};
export default SigmaEventDefinitionSearchAction;
